module.exports = __webpack_public_path__ + "img/sinopec_logo.a33a8397.png";